/*
1. App.js
Görev: 
React uygulamanızın ana bileşenidir. 
Uygulamanın genel yapısını ve başlangıç noktasını tanımlar.
İşlev: 
Şu anda bir örnek React uygulaması içeriyor. 
Logo, bir bağlantı ve basit bir mesaj gösteriyor. 
Bu dosya, uygulamanızın ana sayfasını veya diğer bileşenleri içerecek şekilde özelleştirilebilir.
Öneri: 
Bu dosyayı, psikolog için tasarlayacağınız ana sayfa veya diğer 
sayfaların yönlendirme noktası olarak kullanabilirsiniz.

*/

import React, { useEffect } from 'react'; // YENİ: useEffect import edildi
import { BrowserRouter as Router } from 'react-router-dom';
// YENİ: Redux için gerekli importlar eklendi
import { useDispatch } from 'react-redux';
import { getAdminInfo } from './features/adminInfo/adminInfoSlice';
import AppRoutes from './routes'; 
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  // YENİ: dispatch fonksiyonunu tanımlıyoruz
  const dispatch = useDispatch();

  // YENİ: Uygulama ilk yüklendiğinde admin bilgilerini çekiyoruz
  useEffect(() => {
    dispatch(getAdminInfo());
  }, [dispatch]);

  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
      <ToastContainer />
    </Router>
  );
}

export default App;
